// extracted by mini-css-extract-plugin
module.exports = {"content":"_16mDMM","summary":"_2NIPEc"};